import _ from 'lodash';
import routeParamMappings from '../config/routeParamMappings.json';

export default function translateRouteParams(params, country) {
  if (!country) throw new Error('country required');

  let include = { ...params };
  let exclude = null;

  _.forEach(params, (value, key) => {
    const mappedValue = routeParamMappings[country][value];

    if (typeof mappedValue === 'object' && mappedValue.not) {
      delete include[key];
      exclude = mappedValue.not;
    } else if (mappedValue) {
      include = { ...include, [key]: mappedValue };
    }
  });

  return { include, exclude };
}



// WEBPACK FOOTER //
// ./src/util/translateRouteParams.js